import { ConsortiumQuotation } from './components';

export const StepThree = () => <ConsortiumQuotation />;
